<template>
  <div class="ue_selector sub_industry_selector">
    <ue-select :options="sub_industries" v-model="sub_industry" @input="selected"></ue-select>
  </div>
</template>
<script lang="ts">
import axios from '@lib/apiClient'

export default {
  props: ['value'],
  data() {
    return {
      sub_industry: null,
      sub_industries: [],
    }
  },
  beforeMount() {
    this.fetchSubIndustries()
  },
  methods: {
    fetchSubIndustries() {
      axios.get('/api/sub_industries.json').then((result) => {
        this.sub_industries = result.data.sub_industries
        this.sub_industry = this.sub_industries.filter((s) => s.code == this.value)
      })
    },
    selected() {
      this.$emit('input', this.sub_industry.code)
    },
  },
}
</script>
<style lang="sass" scoped></style>
